import { WebFsError } from '#common/types';
export class MissingConfigKey extends WebFsError {
}
export class ConfigUnavailableError extends WebFsError {
}
